import { CicloI } from "interfaces/Ciclo";
import { ReactNode, useState } from "react";

interface Props {
  elemento: CicloI;
  renderActions?: (elemento: CicloI) => ReactNode;
}

export const CicloRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`ResolucionTable-${elemento.id}`}>
        <td>{elemento.id}</td>
        <td>{elemento.nombre}</td>
        <td>{elemento.descripcion}</td>
        <td>{elemento.anioInicial}</td>
        <td>{elemento.anioFinal}</td>
        {renderActions && (
          <td style={{ maxWidth: "50px" }}>{renderActions(elemento)}</td>
        )}
      </tr>
    </>
  );
};
